import { z } from 'zod'

/**
 * Translations contract of the backend API v1 (OpenAPI: TranslationsOut).
 *   GET /translations/{portal}  → TranslationCatalogue | 404 portal_not_found   public, header: X-Language
 * An unsupported language is answered 200 with the English catalogue: `language` is what was
 * served, `requested_language` what was asked. Field names are the backend's (snake_case).
 */
export const TRANSLATION_PORTAL = 'web'

export const translationCatalogueSchema = z.object({
  portal: z.string(),
  /** The language of the texts in `resources`. */
  language: z.string().min(1),
  /** `null` when the request named no language. */
  requested_language: z.string().nullable(),
  /** The whole catalogue, flat: full dotted key → text, `{name}` placeholders unfilled. */
  resources: z.record(z.string(), z.string()),
})
export type TranslationCatalogue = z.infer<typeof translationCatalogueSchema>
